/** Dual-Kawase bloom (Marius Bjørge, SIGGRAPH 2015): 5-tap downsample, 8-tap tent upsample, then add back. */

export const KAWASE_DOWN_FRAG = /* glsl */ `#version 300 es
precision mediump float;
in vec2 vUv;
out vec4 outColor;
uniform sampler2D uSrc;
uniform vec2 uHalfTexel; // half a texel of the SOURCE
void main() {
  vec2 o = uHalfTexel;
  vec3 c = texture(uSrc, vUv).rgb * 4.0;
  c += texture(uSrc, vUv - o).rgb;
  c += texture(uSrc, vUv + o).rgb;
  c += texture(uSrc, vUv + vec2(o.x, -o.y)).rgb;
  c += texture(uSrc, vUv - vec2(o.x, -o.y)).rgb;
  outColor = vec4(c / 8.0, 1.0);
}
`;

export const KAWASE_UP_FRAG = /* glsl */ `#version 300 es
precision mediump float;
in vec2 vUv;
out vec4 outColor;
uniform sampler2D uSrc;
uniform vec2 uHalfTexel; // half a texel of the SOURCE
void main() {
  vec2 o = uHalfTexel;
  vec3 c = texture(uSrc, vUv + vec2(-o.x * 2.0, 0.0)).rgb;
  c += texture(uSrc, vUv + vec2(-o.x, o.y)).rgb * 2.0;
  c += texture(uSrc, vUv + vec2(0.0, o.y * 2.0)).rgb;
  c += texture(uSrc, vUv + vec2(o.x, o.y)).rgb * 2.0;
  c += texture(uSrc, vUv + vec2(o.x * 2.0, 0.0)).rgb;
  c += texture(uSrc, vUv + vec2(o.x, -o.y)).rgb * 2.0;
  c += texture(uSrc, vUv + vec2(0.0, -o.y * 2.0)).rgb;
  c += texture(uSrc, vUv + vec2(-o.x, -o.y)).rgb * 2.0;
  outColor = vec4(c / 12.0, 1.0);
}
`;

export const COMPOSITE_FRAG = /* glsl */ `#version 300 es
precision mediump float;
in vec2 vUv;
out vec4 outColor;
uniform sampler2D uColor;
uniform sampler2D uBloom;
uniform float uStrength;
void main() {
  vec3 c = texture(uColor, vUv).rgb + texture(uBloom, vUv).rgb * uStrength;
  outColor = vec4(c, 1.0);
}
`;
